import React from 'react';

import { TextInput } from '@gravity-ui/uikit';

import { ExternalFormState } from './AliceExternalAppForm.types';
import { withForm } from './formHook';

/**
 * Numeric preferred-size input (kept as a string in form state so the user can type/erase
 * freely). Built via `withForm` so the parent passes a typed `form` instance and `name` is a
 * narrow deep-key, not `string`.
 */
export const SizeInput = withForm({
    defaultValues: {} as ExternalFormState,
    props: {
        name: '' as
            | `resources[${number}].meta.minWidth`
            | `resources[${number}].meta.maxWidth`
            | `resources[${number}].meta.minHeight`
            | `resources[${number}].meta.maxHeight`,
        placeholder: '',
        disabled: false,
    },
    render: ({ form, name, placeholder, disabled }) => (
        <form.Field name={name}>
            {(field) => (
                <TextInput
                    value={field.state.value}
                    onUpdate={field.handleChange}
                    disabled={disabled}
                    size="m"
                    placeholder={placeholder}
                />
            )}
        </form.Field>
    ),
});
